import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-accepting.component.ajs.html';

const MODULE_NAME = 'agentBookingMailAccepting';

class AgentBookingMailAcceptingCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailAccepting implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailAcceptingCtrl];
}

export default MODULE_NAME;
